import React, { useEffect, useRef, useState } from 'react';
import { Progress, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import './RealtimeProgressUI.css';

const RealtimeProgressUI = ({
  currentStepMessage,
  isVisible = true,
  progress = 0,
  showProgress = true,
}) => {
  // デバッグログを制限（分析中のみ表示）
  // if (isVisible && progress > 0 && progress < 100) {
  //   console.log('🎯 PROGRESS UI RENDER:', {
  //     currentStepMessage,
  //     isVisible,
  //     progress,
  //   });
  // }

  const percentInt = Math.max(
    0,
    Math.min(100, Math.round(Number(progress) || 0)),
  );

  // 簡易スムージング：表示値をターゲットに向けて補間
  const [displayPercent, setDisplayPercent] = useState(percentInt);
  const rafRef = useRef(null);
  const startRef = useRef(0);
  const fromRef = useRef(percentInt);
  const toRef = useRef(percentInt);

  useEffect(() => {
    // 目標値更新（目標が0%の場合でも補間を1→目標への短距離で起動し、静止見えを回避）
    fromRef.current = Math.max(
      displayPercent,
      percentInt === 0 ? 0 : displayPercent,
    );
    toRef.current = percentInt;
    startRef.current = performance.now();

    // 既存アニメーション停止
    if (rafRef.current) cancelAnimationFrame(rafRef.current);

    // 小刻みな0%滞留を避けるため、低進捗帯は早め、以降は滑らかに
    const durationMs = percentInt < 5 ? 250 : percentInt < 50 ? 450 : 650;
    const step = now => {
      const elapsed = now - startRef.current;
      const t = Math.max(0, Math.min(1, elapsed / durationMs));
      const next = Math.round(
        fromRef.current + (toRef.current - fromRef.current) * t,
      );
      setDisplayPercent(next);
      if (t < 1) {
        rafRef.current = requestAnimationFrame(step);
      }
    };
    rafRef.current = requestAnimationFrame(step);

    return () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, [percentInt]);
  if (!isVisible || percentInt >= 100) {
    // 完了時のログは1回のみ（制限）
    if (percentInt >= 100) {
      // ログを完全に停止（リロード時の大量ログ防止）
      return null;
    }
    return null;
  }

  const antIcon = (
    <LoadingOutlined style={{ fontSize: 16, color: 'white' }} spin />
  );

  return (
    <div className="realtime-message-bar">
      <div className="message-content">
        <div className="message-left">
          <Spin indicator={antIcon} size="small" style={{ marginRight: 12 }} />
          <span className="message-text">
            {currentStepMessage || '分析を実行しています...'}
          </span>
        </div>
        {showProgress && (
          <div className="progress-container">
            <Progress
              percent={displayPercent}
              size="small"
              strokeColor="#fff"
              trailColor="rgba(255, 255, 255, 0.3)"
              showInfo={false}
              style={{ minWidth: 120 }}
            />
            <span className="progress-text">{displayPercent}%</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default RealtimeProgressUI;
